import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import TextInput from "../../../../components/inputs/text";
import Loading from "../../../../components/loading";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";

const FormCredenciais = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	setLoading,
	fetchID,
	reloadData,
	reloadFetchFirstData,
	insert,
}) => {
	const {
		register,
		handleSubmit,

		loading,
		errors,
		isSubmitting,
		listTipos,

		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		setLoading,
		fetchID,
		reloadData,
		reloadFetchFirstData,
		insert,
	});

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Aguarde buscando dados no servidor..." />
				</div>
			) : (
				<form className="form" onSubmit={handleSubmit(handleOnSubmit)}>
					<main>
						<div className="row">
							{/* Tipo de credencial — Seleção via banco */}
							<div className="input-select-box d-flex flex-column col-4 col-sm-3 col-lg-2">
								<label htmlFor="id_credenciais_tipo">Tipo API</label>
								<select
									{...register("id_credenciais_tipo", { valueAsNumber: true })}
									className={`${errors.id_credenciais_tipo ? "error" : ""}`}
									onKeyDown={libForm.EnterTab}
									autoFocus={true}
								>
									<option value={0} disabled hidden>
										SELECIONE
									</option>
									{listTipos?.map((tipo) => (
										<option key={tipo.id_credenciais_tipo} value={tipo.id_credenciais_tipo}>
											{tipo.descricao}
										</option>
									))}
								</select>
								{errors.id_credenciais_tipo && (
									<p className="errors">{errors.id_credenciais_tipo.message}</p>
								)}
							</div>

							<TextInput
								label="Descrição"
								id="descricao"
								placeholder="Ex: Evolution API Principal"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-9 col-lg-10"
							/>

							<TextInput
								label="URL do servidor"
								id="url"
								placeholder="Ex: evolution.szsistemas.com.br"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-8"
								toUpperCase={false}
							/>

							<TextInput
								label="API Key"
								id="api_key"
								placeholder="Digite a chave de acesso"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-4"
								type="text"
								toUpperCase={false}
								autoComplete="off"
								style={{ WebkitTextSecurity: "disc" }}
							/>

							<TextInput
								label="Observação"
								id="obs"
								placeholder=""
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12"
							/>

							<div className={`check-box-top col-12`}>
								<div className="check-input">
									<input
										className={`${errors.ativo ? "error" : ""}`}
										id="ativo_credencial"
										type="checkbox"
										{...register("ativo")}
										autoComplete="off"
									/>
									<label htmlFor="ativo_credencial">
										<span className="text-sm">Credencial ativa</span>
									</label>
								</div>
							</div>
						</div>
					</main>
					<footer>
						<BtnBack onClick={() => handleCloseModalRegister()} isSubmitting={isSubmitting} />
						<BtnSubmit isSubmitting={isSubmitting} />
					</footer>
				</form>
			)}
		</>
	);
};

export default FormCredenciais;
